export const dataSourcePageIDMap: { [key: string]: string } = {
  newzoo: 'ogdb',
  ampere: 'Other Vendor',
};
